import { gaPushEvent } from "../base.analytics";

enum Event {
  SEARCH = "search",
  SEARCH_TAB_SELECTED = "search_tab_selected",
  SEARCH_RESULT_CLICKED = "search_result_clicked",
  MESH_SUGGESTION_CLICKED = "mesh_suggestion_clicked",
}

export type SearchEventCategory =
  | "all"
  | "articles"
  | "rooms"
  | "playlists"
  | "journals"
  | "podcasts"
  | "videos"
  | "users"
  | "author_articles";

export type SearchSource = "typed" | "history" | "suggestion";
export type SearchScopeKind = "global" | "room";
export type SearchResultType = "room" | "article" | "journal" | "playlist";

export function gaEventSearch(args: {
  term: string;
  resultsCount: number;
  category: SearchEventCategory;
  source: SearchSource;
  scope: SearchScopeKind;
}) {
  gaPushEvent(Event.SEARCH, {
    search: {
      term: args.term,
      results_count: args.resultsCount,
      type: args.category,
      source: args.source,
      scope: args.scope,
    },
  });
}

export function gaEventSearchTabSelected(args: {
  from: SearchEventCategory;
  to: SearchEventCategory;
  term: string;
}) {
  gaPushEvent(Event.SEARCH_TAB_SELECTED, {
    search_tab: {
      from: args.from,
      to: args.to,
      term: args.term,
    },
  });
}

export function gaEventSearchResultClicked(args: {
  term: string;
  category: SearchEventCategory;
  resultType: SearchResultType;
  resultId: string;
  position: number;
  scope: SearchScopeKind;
}) {
  gaPushEvent(Event.SEARCH_RESULT_CLICKED, {
    search_result: {
      term: args.term,
      category: args.category,
      result_type: args.resultType,
      result_id: args.resultId,
      position: args.position,
      scope: args.scope,
    },
  });
}

export function gaEventMeshSuggestionClicked(args: {
  term: string;
  isPrimarySpecialty: boolean;
}) {
  gaPushEvent(Event.MESH_SUGGESTION_CLICKED, {
    mesh_suggestion: {
      term: args.term,
      is_primary_specialty: args.isPrimarySpecialty,
    },
  });
}
